<template>
  <div id="tab1" class="t-color-content1 pdl-16 pdr-16 pdb-32">
    <div class="pdt-48"></div>
    <div class="pdt-50"></div>
    <div class="mgt-50">
      <img
        src="images/portfolio/notice-no-data.svg"
        alt=""
        class="d-block mgx-auto notice-no-data"
      />
    </div>

    <div
      class="t-color-title t-subtitle3 t-center pdt-26 pdb-8 l-spacing48 font-m"
    >
      {{$t('3032')}}
    </div>
    <div class="t-color-content1 t-body3 t-center l-spacing42 font-r">
      {{$t('3033')}}
      <!-- <br />
      학습을 시작하고 좋아요를 눌러보세요! -->
    </div>
  </div>
</template>

<script>
// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { MDCTabBar, MDCTabBarFoundation } from "@material/tab-bar";

export default {
  name: "learn",

  data() {
    return {
      // title
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      tabBar: null,
    };
  },
  components: {
    TopAppBar,
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {},
  },
};
</script>

<style scoped>
.notice-no-data {
  width: 109px;
  height: 74px;
}
</style>